'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Row = _next.Grid.Row,
    Col = _next.Grid.Col;


var SEARCH_KEY = 'searchKey';
var SEARCH_FIELD = 'searchField';
var UNSUPPORTED_COMPONENT_TYPES = ['Attachment'];

var convertRelationship = function convertRelationship(searchColumns) {
  var relationship = {};
  !(0, _lodash.isEmpty)(searchColumns) && searchColumns.forEach(function (item) {
    relationship[item[SEARCH_KEY]] = item[SEARCH_FIELD];
  });
  return relationship;
};

var convertSearchColumnArr = function convertSearchColumnArr(searchColumns) {
  return !(0, _lodash.isEmpty)(searchColumns) ? searchColumns.filter(function (item) {
    return !!item[SEARCH_FIELD];
  }).map(function (item) {
    return item[SEARCH_FIELD];
  }) : [];
};

var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onReset = function () {
      var searchColumnArr = _this.state.searchColumnArr;

      searchColumnArr.forEach(function (fieldId) {
        try {
          var state = _this.$state.get(fieldId);
          // 重置组件值
          state.reset(['fieldData', 'hasError', 'errorMsg']);
        } catch (e) {}
      });
    };

    var searchColumns = props.searchColumns,
        owner = props.owner,
        formKey = props.formKey;

    _this.state = {
      relationship: convertRelationship(searchColumns),
      searchColumnArr: convertSearchColumnArr(searchColumns)
    };
    owner.set('searchColumns-' + formKey, {});
    _this.$state = owner.get('searchColumns-' + formKey);
    return _this;
  }

  Search.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var initCallback = this.props.initCallback;
    var searchColumnArr = this.state.searchColumnArr;

    searchColumnArr.forEach(function (fieldId) {
      try {
        var state = _this2.$state.get(fieldId);
        // 禁用组件校验方法
        state.disableValid();
        // 重设组件值
        state.reset(['fieldData', 'hasError', 'errorMsg']);
        state.setData({ readonly: false, disabled: false, visible: true }, true);
      } catch (e) {}
    });
    initCallback && initCallback(this);
  };

  Search.prototype.getData = function getData() {
    var _this3 = this;

    var searchColumnArr = this.state.searchColumnArr;

    var formData = {};
    searchColumnArr.forEach(function (fieldId) {
      var fieldData = void 0;
      try {
        var state = _this3.$state.get(fieldId);
        fieldData = state.getVal();
      } catch (e) {}
      formData[fieldId] = fieldData;
    });
    return {
      value: JSON.stringify(formData)
      // relationship
    };
  };

  Search.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        searchHandler = _props.searchHandler;
    var searchColumnArr = this.state.searchColumnArr;

    var __ownerScope = this.$state;
    var childElms = !(0, _lodash.isEmpty)(children) && children.filter(function (item) {
      var fieldId = void 0;
      var componentName = void 0;
      try {
        fieldId = item.props.componentSchema.props.fieldId;
        componentName = item.props.componentSchema.componentName;
      } catch (e) {}
      // TODO 过滤不支持的组件列表
      return UNSUPPORTED_COMPONENT_TYPES.indexOf(componentName) === -1 && searchColumnArr.indexOf(fieldId) > -1;
    }).map(function (child) {
      // TODO 搜索表单剔除校验规则，只读，disable，visible
      var componentSchema = JSON.parse(JSON.stringify(child.props.componentSchema));
      // const componentSchema = cloneDeep(child.props.componentSchema);
      componentSchema.props.validation = [];
      return _react2.default.cloneElement(child, {
        __ownerScope: __ownerScope,
        componentSchema: componentSchema,
        disableFieldSelect: true, // 卡片禁用子组件的表单项选择模式，服务端不支持
        enableInputBalloon: false // 禁止Input子组件开启气泡提示
      });
    });
    return !(0, _lodash.isEmpty)(childElms) ? _react2.default.createElement(
      'div',
      { className: 'vc-big-table-search-form' },
      childElms,
      _react2.default.createElement(
        'div',
        { className: 'vc-big-table-search-form-btn' },
        _react2.default.createElement(
          _next.Button,
          {
            style: { width: '75px' },
            type: 'secondary',
            onClick: function onClick() {
              searchHandler();
            }
          },
          '\u641C\u7D22'
        ),
        _react2.default.createElement(
          _next.Button,
          { style: { width: '75px', marginLeft: '20px' }, type: 'normal', onClick: this.onReset },
          '\u91CD\u7F6E'
        )
      )
    ) : null;
  };

  return Search;
}(_react.Component);

exports.default = Search;
module.exports = exports['default'];